import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import { ToolbarUndoRedoActions, ToolbarShowMoreActions, ToolbarFormatActions } from './components';
import useStyles from './useStyles';
import { useResponsiveFormatButtons } from './useResponsiveFormatButtons';

export const FixedToolbar = ({
  buttonFormatsToDisplay,
  onClearFormatting,
  className,
  wrapperRef,
}) => {
  const styles = useStyles();
  const { visibleButtons, hiddenButtons } = useResponsiveFormatButtons({
    formatButtons: buttonFormatsToDisplay,
    wrapperElement: wrapperRef.current,
  });

  return (
    <div className={cx(styles.root, className)}>
      {visibleButtons.length > 0 && (
        <ToolbarFormatActions
          buttonFormatsToDisplay={visibleButtons}
        />
      )}
      {hiddenButtons.length > 0 && (
        <ToolbarShowMoreActions
          buttonFormatsToDisplay={hiddenButtons}
        />
      )}
      <ToolbarUndoRedoActions
        onClearFormatting={onClearFormatting}
        className={styles.formatButton}
      />
    </div>
  );
};

FixedToolbar.propTypes = {
  buttonFormatsToDisplay: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.string)),
  className: PropTypes.string,
  onClearFormatting: PropTypes.func.isRequired,
  wrapperRef: PropTypes.shape({
    current: PropTypes.shape({}),
  }),
};

FixedToolbar.defaultProps = {
  buttonFormatsToDisplay: [],
  className: '',
  wrapperRef: {},
};
